namespace GeniuzPOS.ReportMasterData {
    export class Report_1333Columns {
        static columnsKey = 'ReportMasterData.Report_1333';
    }
}
